import { gsap } from 'gsap/dist/gsap';

const tempNav = () => {
  $(() => {
    let topAmount = 0;
    $(window).on('scroll', function () {
      let topAmount = $(this).scrollTop();
      if (topAmount > 225) {
        $('#temp-nav-wrap').css('z-index', '1000');
        gsap.to($('#temp-nav-wrap'), {
          opacity: '1',
          duration: '1',
          ease: 'power4.out',
        });
      } else {
        $('#temp-nav-wrap').css('z-index', '0');
        gsap.to($('#temp-nav-wrap'), {
          opacity: '0',
          duration: '.5',
          // zIndex: '0',
          ease: 'power4.out',
        });
      }
    });
  });
};

export default tempNav;
